import { useCallback, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { Control, useFieldArray } from 'react-hook-form-mui';
import List from '@mui/material/List';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Order } from '../../../../../Models';
import { ProductField, ProductsForm } from '../../../types/editableOfferCard.formValues';
import { ProductItem } from './ProductItem';
import { ProductSearch } from '../../../../../services/api/dto/search.dto';

const createEmptyItem = (): ProductField => ({
    discount_percent: undefined,
    id: '',
    name: '',
    quantity: 1,
    unit_price: 0,
});
type PrescriptionInputProps = {
    order: Order;
    disabled: boolean;
    control: Control<ProductsForm>;
};
function ProductsInput({ order, disabled, control }: PrescriptionInputProps) {
    const { fields, remove, append, update } = useFieldArray({
        control,
        name: 'products',
        rules: { minLength: 1 },
        keyName: 'key',
    });

    useEffect(() => {
        if (!fields.length) {
            append(createEmptyItem());
        }
    }, [append, fields.length]);
    const addListItem = () => append(createEmptyItem());

    const setProduct = useCallback(
        (index: number, product: ProductSearch) => {
            update(index, {
                ...fields[index],
                id: product.id,
                name: product.description,
                generic_name: product.monodrug,
                family: product.family,
                laboratory: product.laboratory,
                unit_price: product.price,
            });
        },
        [fields, update],
    );

    return (
        <Stack direction="column" alignItems="flex-start" spacing={1}>
            <List sx={{ width: 1, p: 0 }}>
                <ListItem key="header" sx={{ p: 0, m: 0 }} disablePadding disableGutters>
                    <Typography variant="body2" sx={{ width: '2%' }} />
                    <Typography variant="body2" textAlign="left" sx={{ width: '43%' }}>
                        Nombre
                    </Typography>
                    <Typography variant="body2" textAlign="right" sx={{ width: '15%' }}>
                        Cant.
                    </Typography>
                    <Typography variant="body2" textAlign="right" sx={{ width: '17%' }}>
                        Dto.
                    </Typography>
                    <Typography variant="body2" textAlign="right" sx={{ width: '25%' }}>
                        Precio u. sin dto.
                    </Typography>
                </ListItem>
                {fields.map((field, i) => (
                    <ProductItem
                        key={`ProductItem-${field.key}`}
                        index={i}
                        onClickRemoveItem={() => remove(i)}
                        disabledInputs={disabled}
                        control={control}
                        setProduct={setProduct}
                    />
                ))}
            </List>
            {order.state !== 'validated' && (
                <Box sx={{ width: 1, display: 'flex', justifyContent: 'center' }}>
                    <Tooltip title="Agregar producto" enterDelay={2000}>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={addListItem}
                            sx={{ width: '6rem' }}>
                            <AddCircleIcon />
                        </Button>
                    </Tooltip>
                </Box>
            )}
        </Stack>
    );
}

export { ProductsInput };
